var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "aside",
    { attrs: { "aria-label": "Site menu" } },
    [
      _c("slide-in-menu", {
        staticClass: "c-sitemenu",
        attrs: { "is-open": _vm.isOpen },
        on: { close: _vm.close },
        scopedSlots: _vm._u(
          [
            {
              key: "tools",
              fn: function() {
                return [_vm._t("tools")]
              },
              proxy: true
            },
            {
              key: "body",
              fn: function() {
                return [_vm._t("body")]
              },
              proxy: true
            }
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }